import React, { useState, useRef, useEffect } from 'react';
import { Toast } from "primereact/toast";
import { Button } from "primereact/button";
import { InputNumber } from 'primereact/inputnumber';
import { postRequest, getRequest } from '../services/apiService';

const StageBudgetAllocationCard = ({ setActiveSubPopup, setShowSelectionPopup, editTransaction }) => {
  const toast = useRef(null);
  const [stages, setStages] = useState([]);
  const [shipBudget, setShipBudget] = useState(1000000);
  const [autoCalculate, setAutoCalculate] = useState(false);
  const [loading, setLoading] = useState(false);
  const [fetchingStages, setFetchingStages] = useState(true);
  const [projects, setProjects] = useState([]);
  const [project, setProject] = useState('');
  const [ships, setShips] = useState([]);
  const [ship, setShip] = useState('');

  useEffect(() => {
    if(project && ship){
    const fetchStages = async () => {
      try {
        setFetchingStages(true);
        const response = await getRequest(`test/task-transaction-api?project_id=${ship}&task_type=milestone&milestone__milestone_type=payment`);
        if (response.data && Array.isArray(response.data)) {
          const formattedStages = response.data.sort((a, b) => a.id - b.id).map(stage => ({
            name: stage.name,
            Stage: stage.id,
            percentage: 0,
            budget: 0,
            id: stage.id
          }));
          setStages(formattedStages);
        } else {
          toast.current?.show({ severity: 'error', summary: 'Error', detail: 'Failed to fetch stages', life: 3000 });
        }
      } catch (error) {
        toast.current?.show({ severity: 'error', summary: 'Error', detail: error.message || 'Failed to fetch stages', life: 3000 });
      } finally {
        setFetchingStages(false);
      }
    }; fetchStages();
    }
  }, [project,ship]);

useEffect(() => {
  if(editTransaction){
    setProject(editTransaction.project.id);
    setShip(editTransaction.ship.id);
    // setStages(editTransaction.stages);
  }
}, [editTransaction]);
  useEffect(() => {
    getRequest('/master/projects/').then(res => {
      setProjects(res?.data || []);
    });
  }, []);

  useEffect(() => {
    if (!project) {
      setShips([]);
      setStages([]);
      return;
    }
    getRequest(`/master/projects/?parent_id=${project}`).then(res => {
      setShips(res?.data || []);
    });
  }, [project]);

  const handleStageInputChange = (stageIndex, field, value) => {
    if (autoCalculate) return;

    if (field === 'percentage') {
      let newValue = parseFloat(value) || 0;
      const sumOther = stages.reduce((acc, stage, idx) =>
        idx === stageIndex ? acc : acc + (parseFloat(stage.percentage) || 0), 0
      );
      if (sumOther + newValue > 100) {
        newValue = Math.max(0, 100 - sumOther);
        toast.current?.show({
          severity: 'warn',
          summary: 'Warning',
          detail: 'Total percentage cannot exceed 100%',
          life: 3000
        });
      }
      setStages(prevStages => prevStages.map((stage, idx) => {
        if (idx === stageIndex) {
          const budget = ((newValue / 100) * shipBudget).toFixed(2);
          return { ...stage, percentage: newValue, budget };
        }
        return stage;
      }));
    }
  };

  const handleStageSubmit = async () => {
    setLoading(true);
    console.log(stages);
    try {
      // Validate total percentage
      const totalPercentage = stages.reduce((acc, stage) => acc + (parseFloat(stage.percentage) || 0), 0);
      console.log(totalPercentage);
      if (Math.abs(totalPercentage - 100) > 0.0001) {
        toast.current?.show({
          severity: 'error',
          summary: 'Error',
          detail: 'Total percentage must equal 100%',
          life: 3000
        });
        return;
      }

      // Validate all stages have values
      const hasEmptyFields = stages.some(stage => 
        stage.percentage === null || stage.budget === null
      );
      if (hasEmptyFields) {
        toast.current?.show({
          severity: 'error',
          summary: 'Error',
          detail: 'Please fill all required fields',
          life: 3000
        });
        return;
      }

      // Prepare data for submission
      const stageData = {
        shipBudget,
        stages: stages.map(stage => ({
          name: stage.name,
          percentage: parseFloat(stage.percentage),
          budget: parseFloat(stage.budget)
        }))
      };

      // Submit to API
    //   const response = await postRequest("/transaction/stage-budgets/", stageData);

      toast.current?.show({
        severity: 'success',
        summary: 'Success',
        detail: 'Stage budgets saved successfully',
        life: 3000
      });

      // Reset form
      handleReset();
    } catch (error) {
      console.error('Error submitting stage budgets:', error);
      toast.current?.show({
        severity: 'error',
        summary: 'Error',
        detail: error.message || 'Failed to save stage budgets',
        life: 3000
      });
    } finally {
      setLoading(false);
    }
  };

  const handleReset = () => {
    setStages(stages.map(stage => ({
      ...stage,
      percentage: null,
      budget: null
    })));
    setAutoCalculate(false);
    setShipBudget(1000000);
  };

  return (
    <div className="py-4">
      <Toast ref={toast} position="top-right" />

     

      <div className='flex justify-between'>
        <div>
        <Button label="Back" icon="pi pi-arrow-left" className="bg-red-500 text-white px-4 py-2 rounded-md w-32" onClick={() => {
          setActiveSubPopup(null);
          setShowSelectionPopup(true);
        }} />
        </div>
       
        <div className="flex space-x-4 mb-4">
          <div className="relative w-40">
            <label htmlFor="project" className="block text-sm font-medium text-gray-700 mb-1">Select Project</label>
            <div className="relative">
              <select
                id="project"
                className="appearance-none block w-full px-3 py-2 border border-indigo-300 rounded-lg shadow-sm focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 bg-white transition-all"
                value={project}
                onChange={(e) => setProject(e.target.value)}
                disabled={loading}
              >
                <option value="" disabled>Select Project</option>
                {projects.map(project => (
                  <option key={project.id} value={project.id}>{project.name}</option>
                ))}
              </select>
              <span className="absolute inset-y-0 right-0 flex items-center pr-2 pointer-events-none">
                <svg className="h-4 w-4 text-gray-400" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" aria-hidden="true">
                  <path fillRule="evenodd" d="M5.23 7.21a.75.75 0 011.06.02L10 10.94l3.71-3.71a.75.75 0 111.06 1.06l-4.25 4.25a.75.75 0 01-1.06 0L5.23 8.27a.75.75 0 01.02-1.06z" clipRule="evenodd" />
                </svg>
              </span>
            </div>
          </div>
          <div className="relative w-40">
            <label htmlFor="ship" className="block text-sm font-medium text-gray-700 mb-1">Select Ship</label>
            <div className="relative">
              <select
                id="ship"
                className="appearance-none block w-full px-3 py-2 border border-indigo-300 rounded-lg shadow-sm focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 bg-white transition-all"
                value={ship}
                onChange={(e) => setShip(e.target.value)}
                disabled={loading || !project}
              >
                <option value="" disabled>Select Ship</option>
                {ships.map(ship => (
                  <option key={ship.id} value={ship.id}>{ship.name}</option>
                ))}
              </select>
              <span className="absolute inset-y-0 right-0 flex items-center pr-2 pointer-events-none">
                <svg className="h-4 w-4 text-gray-400" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" aria-hidden="true">
                  <path fillRule="evenodd" d="M5.23 7.21a.75.75 0 011.06.02L10 10.94l3.71-3.71a.75.75 0 111.06 1.06l-4.25 4.25a.75.75 0 01-1.06 0L5.23 8.27a.75.75 0 01.02-1.06z" clipRule="evenodd" />
                </svg>
              </span>
            </div>
          </div>

          <div className="flex items-center mt-4">
          <label className="mr-2 font-medium text-gray-700">Auto Calculate</label>
          <input
              type="checkbox"
              checked={autoCalculate}
              disabled={fetchingStages}
              onChange={e => {
                const checked = e.target.checked;
                setAutoCalculate(checked);
              
                if (!checked || stages.length === 0) return;
              
                const n = stages.length;
              
                /* ---------- 1 .  Split the budget equally ---------- */
                const rawAmt  = shipBudget / n;                     // ideal share
                const amtArr  = Array(n).fill(+rawAmt.toFixed(2));  // round to 2-dp
                const amtGap  = +(shipBudget -
                                 amtArr.reduce((s, v) => s + v, 0)).toFixed(2);
                amtArr[n - 1] = +(amtArr[n - 1] + amtGap).toFixed(2);   // exact total
              
                /* ---------- 2 .  Derive percentages from budgets ---------- */
                const pctArr  = amtArr.map(a =>
                  +((a / shipBudget) * 100).toFixed(2)
                );
                const pctGap  = +(100 -
                                 pctArr.reduce((s, v) => s + v, 0)).toFixed(2);
                pctArr[n - 1] = +(pctArr[n - 1] + pctGap).toFixed(2);    // exact 100 %
              
                /* ---------- 3 .  Update state ---------- */
                setStages(stages.map((stage, i) => ({
                  ...stage,
                  budget     : amtArr[i],   // sums to shipBudget
                  percentage : pctArr[i]    // sums to 100.00 %
                })));
              }}
              
  
  className="form-checkbox h-5 w-5 text-indigo-600"
/>

        </div>
        </div>
       
      </div>
          
          <div className='bg-indigo-50 rounded-lg p-4 mb-2'>
            <div className="grid grid-cols-3 gap-5">
              <div className="bg-white p-4 rounded shadow-sm">
                <div className="flex items-center justify-between mb-2">
                  <p className="text-sm text-gray-500">Total Ship Budget</p>
                  <span className="text-xs px-2 py-1 bg-blue-100 text-blue-800 rounded-full">100%</span>
                </div>
                <p className="text-xl font-semibold text-gray-900">₹{shipBudget}Cr</p>
                <div className="mt-2 text-xs text-gray-500">
                  Fiscal Year 2023-24
                </div>
              </div>
              <div className="bg-white p-4 rounded shadow-sm">
                <div className="flex items-center justify-between mb-2">
                  <p className="text-sm text-gray-500">Utilized Budget</p>
                  <span className="text-xs px-2 py-1 bg-green-100 text-green-800 rounded-full">
                    {stages.reduce((acc, stage) => acc + (parseFloat(stage.percentage) || 0), 0).toFixed(2)}%
                  </span>
                </div>
                <p className="text-xl font-semibold text-green-600">
                  ₹{stages.reduce((acc, stage) => acc + (parseFloat(stage.budget) || 0), 0).toFixed(2)}Cr
                </p>
                <div className="mt-2 text-xs text-gray-500">
                  Updated {new Date().toLocaleDateString()}
                </div>
              </div>
              <div className="bg-white p-4 rounded shadow-sm">
                <div className="flex items-center justify-between mb-2">
                  <p className="text-sm text-gray-500">Remaining Budget</p>
                  <span className="text-xs px-2 py-1 bg-orange-100 text-orange-800 rounded-full">
                    {(100 - stages.reduce((acc, stage) => acc + (parseFloat(stage.percentage) || 0), 0)).toFixed(2)}%
                  </span>
                </div>
                <p className="text-xl font-semibold text-orange-600">
                  ₹{(shipBudget - stages.reduce((acc, stage) => acc + (parseFloat(stage.budget) || 0), 0)).toFixed(2)}Cr
                </p>
                <div className="mt-2 text-xs text-gray-500">
                  Available Balance
                </div>
              </div>
            </div>
          </div>

      {fetchingStages ? (
        <div className="flex justify-center items-center h-64">
          <div className="animate-spin rounded-full h-12 w-12 border-t-2 border-b-2 border-indigo-500"></div>
        </div>
      ) : (
        <>
         
          <div className='bg-indigo-50 rounded-lg p-4 mb-2'>
            <table className="min-w-full divide-y divide-gray-200">
              <thead className="bg-gray-50">
                <tr>
                  <th width="30%" className="px-6 py-4 text-left font-semibold text-lg text-gray-500 uppercase tracking-wider">Stage Name</th>
                  <th width="30%" className="px-6 py-4 text-left font-semibold text-lg text-gray-500 uppercase tracking-wider">Percentage</th>
                  <th width="30%" className="px-6 py-4 text-left font-semibold text-lg text-gray-500 uppercase tracking-wider">Amount</th>
                </tr>
              </thead>
              <tbody className="bg-white divide-y divide-gray-200">
                {stages.map((stage, idx) => (
                  <tr key={stage.name} className="hover:bg-gray-50">
                    <td className="px-6 py-4 whitespace-nowrap">{stage.name}</td>
                    <td className="px-6 py-4 whitespace-nowrap">
                      <InputNumber
                        value={stage.percentage}
                        onValueChange={(e) => handleStageInputChange(idx, 'percentage', e.value)}
                        disabled={autoCalculate}
                        min={0}
                        max={100}
                        step={1}
                        mode="decimal"
                        suffix="%"
                        className="w-full border-1 border-gray-400 rounded-md "
                        minFractionDigits={0}
                        maxFractionDigits={5}
                      />
                    </td>
                    <td className="px-6 py-4 whitespace-nowrap">
                      <div className="flex items-center border-1 border-gray-300 rounded-md bg-gray-100">
                        <InputNumber
                          value={stage.budget}
                          disabled
                          
                          mode="currency"
                          currency="INR"
                          locale="en-IN"
                          className="w-full border-1 border-gray-400 rounded-md b"
                          minFractionDigits={2}
                          maxFractionDigits={2}
                        />
                        <span className="mx-2 bg-gray-100">Cr</span>
                      </div>
                    </td>
                  </tr>
                ))}
                <tr>
                  <td></td>
                  <td></td>
                  <td className="px-6 py-4 whitespace-nowrap flex justify-end gap-2">
                    <Button
                      label="Reset"
                      icon="pi pi-refresh"
                      className="bg-red-500 text-white px-4 py-2 rounded-md w-32"
                      onClick={handleReset}
                      disabled={loading}
                    />
                    <Button
                      label={loading ? 'Saving...' : 'Save'}
                      icon="pi pi-check"
                      className="bg-indigo-700 text-white px-4 py-2 rounded-md w-32"
                      onClick={handleStageSubmit}
                      loading={loading}
                    />
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </>
      )}
    </div>
  );
};

export default StageBudgetAllocationCard; 